import React, { useState, useContext, useEffect, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import P from 'prop-types';
import './styles.css';
import { Modal } from '../../components/Modal';
import { useSocketio } from '../../contexts/SocketioContext';
import { GlobalContext } from '../../contexts/HomeContext';
import { ArredondaValores, isObjectEmpty, GetItensMontagem, RemoveUser } from '../../utils/utils';
import { toast } from 'react-toastify';

export const AutoAtendimento = ({ param }) => {
  const { dadosApp, statusLoja, user, setUser, setEnderecos } = useContext(GlobalContext);
  const [title, setTitle] = useState('Mesa ' + dadosApp.Qs.mesa);
  const [modalLoading, setModalLoading] = useState(false);
  const [modalConferencia, setModalConferencia] = useState(false);
  const [modalLogin, setModalLogin] = useState(false);
  const [modalMeusDados, setModalMeusDados] = useState(false);
  const [modalCartoes, setModalCartoes] = useState(false);
  const [modalCamera, setModalCamera] = useState(false);
  const [modalPergunta, setModalPergunta] = useState(false);
  const [itens, setItens] = useState([]);
  const { socketResponse, socketEmit } = useSocketio();
  const navigate = useNavigate();

  const handleLogout = () => {
    RemoveUser(dadosApp.IdLoja, setUser, setEnderecos);
  };

  const options = useMemo(
    () => [
      {
        _id: 1,
        text: 'Faça seu Pedido',
        // description: 'Realizar um pedido na mesa',
        icon: 'https://img.icons8.com/ios/42/000000/restaurant.png',
        disabled: false,
      },
      {
        _id: 2,
        text: 'Sua Conta',
        // description: dadosApp.portaria ? 'Conferir o consumo da comanda' : 'Conferir o consumo da mesa',
        icon: 'https://img.icons8.com/ios/42/000000/check--v1.png',
        disabled: false,
      },
      {
        _id: 3,
        text: 'Veja o Cardápio',
        // description: 'Visualizar o Cardápio    ',
        icon: 'https://img.icons8.com/ios/42/000000/restaurant-menu.png',
        disabled: dadosApp.Empresa.Config.cardapio_externo === 0,
      },
      {
        _id: 4,
        text: !user.ativo ? 'Login' : 'Meus Dados',
        // description: !user.ativo ? 'Entrar ou Cadastrar-se    ' : 'Visualizar meu cadastro    ',
        icon: !user.ativo
          ? 'https://img.icons8.com/ios/42/login-rounded-right.png'
          : 'https://img.icons8.com/ios/42/user-male-circle.png',
        disabled: dadosApp.aceitaPagamentoSemUsuario || !dadosApp.Empresa.Config.aceitar_pagamento,
        // disabled: !dadosApp.Empresa.Config.aceitar_pagamento || dadosApp.aceitaPagamentoSemUsuario,
      },
      {
        _id: 5,
        text: 'Cartões',
        // description: 'Meus cartões cadastrados    ',
        icon: 'https://img.icons8.com/ios/42/bank-cards.png',
        disabled: !user.ativo,
      },
      {
        _id: 6,
        text: 'Deslogar',
        // description: 'deslogar da sua conta    ',
        icon: 'https://img.icons8.com/ios/42/logout-rounded--v2.png',
        disabled: !user.ativo,
        // disabled: !dadosApp.Empresa.Config.aceitar_pagamento || !user.ativo,
      },
      {
        _id: 7,
        text: 'Fale Conosco',
        // description: 'Tem alguma dúvida?    ',
        icon: 'https://img.icons8.com/ios/42/000000/whatsapp--v1.png',
        disabled: dadosApp.Empresa.Config.whatsapp_gerencia === 0,
      },
    ],
    [dadosApp, dadosApp.aceitaPagamentoSemUsuario, user],
  );

  const handleSocketEmit = async (comanda = 0) => {
    let _qs = { ...dadosApp.Qs };
    _qs.Solicitacao = '2'; // CONFERENCIA
    dadosApp.Qs.comanda = comanda; // alimenta o numero da comanda

    if (comanda > 0) _qs.mesa = comanda;

    // if (moduloMesa) {
    //   _qs.portaria = 'false';
    // } else {
    _qs.portaria = dadosApp.portaria.toString();
    // }

    _qs.Body = JSON.stringify(_qs);

    socketEmit(_qs);
  };

  const handleConferencia = useCallback((dados) => {
    let Subtotal = 0;
    let Total = 0;
    let Servico = 0;
    let Acrescimo = 0;
    let Desconto = 0;
    let itens = [];
    // CALCULA OS TOTAIS
    if (dados) {
      itens = dados
        .filter(
          ({ montagem_id, adicionais_id, obrigatorio_id }) =>
            montagem_id == 0 && adicionais_id == 0 && obrigatorio_id == 0,
        )
        .map((item) => {
          if (item.principal_id > 0) {
            const montagem = GetItensMontagem(item.ItensMontagem, item); //param.Empresa.Config.pizza_cobranca

            if (item.tipo_produto.toUpperCase() === 'COMBO') {
              montagem.vTotal = 0;
              montagem.vAcrescimo = 0;
              montagem.vDesconto = 0;
              montagem.vServico = 0;
              item.ItensMontagem.map((mont) => {
                montagem.vTotal += mont.subtotal;
                montagem.vAcrescimo += mont.acrescimo;
                montagem.vDesconto += mont.desconto;
                montagem.vServico += mont.servico;
              });
            }
            Subtotal += montagem.vTotal;
            Acrescimo += montagem.vAcrescimo;
            Desconto += montagem.vDesconto;
            Servico += montagem.vServico;
            //Subtotal += item.subtotal;
            return {
              Produto: item,
              ItensMontagemText: montagem.itensMontagem,
              VTotal: montagem.vTotal,
              VDesconto: montagem.vDesconto,
              VAcrescimo: montagem.vAcrescimo,
              vServico: montagem.vServico,
            };
          } else {
            // Subtotal += item.total;
            Subtotal += item.subtotal;
            Acrescimo += item.acrescimo;
            Desconto += item.desconto;
            Servico += item.servico;
            //return { Produto: item, ItensMontagemText: '', VTotal: item.total };
            return {
              Produto: item,
              ItensMontagemText: '',
              VTotal: item.subtotal,
              VDesconto: item.desconto,
              VAcrescimo: item.acrescimo,
              vServico: item.servico,
            };
          }
        });

      //Taxa = ArredondaValores((Subtotal * dadosApp.Empresa.Config.taxa_valor) / 100, 2);
      Total = Subtotal + Servico + Acrescimo - Desconto;
    } // CALCULA OS TOTAIS

    setItens({
      itens: itens,
      total: ArredondaValores(Total, 2),
      subtotal: ArredondaValores(Subtotal, 2),
      taxa: ArredondaValores(Servico, 2),
      desconto: ArredondaValores(Desconto, 2),
      acrescimo: ArredondaValores(Acrescimo, 2),
    });
    setModalConferencia(true);
  }, []);

  const handleResposta = useCallback(
    (data) => {
      if (data) {
        setModalLoading(false);

        if (data.Solicitacao !== '2') {
          if (data.Solicitacao !== '1') {
            if (data.Solicitacao !== '0') {
              if (data.Solicitacao !== '5') {
                navigate('/loja/Page404?message=Solicitação Não Homologada');
              }
            }
          }
          return;
        }

        if (data.Solicitacao === '2') {
          if (data.readed) return;
          if (data.Status === 0) {
            const dados = JSON.parse(data.Body);
            if (dados === null) return;

            if (dados.retorno === 'sucesso') {
              setTitle('Comanda ' + dados.mesaCartao);
              handleConferencia(dados.conferencia_desagrupada);
            } else toast.error(dados.msgerror);
            //history.push('/loja/Page404?message=' + dados.msgerror);
          } else {
            navigate('/loja/Page404?message=' + data.Body);
          }
        }
      } else {
        navigate('/loja/Page404?message=Erro ao obter resposta');
      }
      data.readed = true;
    },
    [navigate, handleConferencia],
  );

  const handleConfirmacaoTemComanda = (possuiComanda) => {
    setModalPergunta(false);

    if (!possuiComanda) {
      setModalLoading(true);
      handleSocketEmit(0);
    } else {
      setModalCamera(true);
    }
  };

  const getFourthFromEnd = (url) => {
    const parts = url.split('/');
    if (parts.length < 4) return null;

    const value = parts[parts.length - 4];
    const isOnlyDigits = /^\d+$/.test(value);

    return isOnlyDigits ? Number(value) : null;
  };

  const extractComandaFromQrCode = (qrCodeData) => {
    // 1. Tenta extrair da URL no formato Qlub
    const fromUrl = getFourthFromEnd(qrCodeData);
    if (fromUrl) return fromUrl;

    // 2. Se não conseguiu, tenta converter direto para número
    const asNumber = Number(qrCodeData);
    if (!isNaN(asNumber)) return asNumber;

    // 3. Nenhum formato válido
    return null;
  };

  const handleQrCode = (qrCodeData) => {
    let comandaNumber = qrCodeData;

    // Processa QR Code da Qlub se configurado
    if (dadosApp?.Empresa?.Config?.qlub) {
      try {
        const extractedComanda = extractComandaFromQrCode(qrCodeData);

        if (!extractedComanda) {
          toast.error('QRCode Inválido, verifique!');
          return;
        }

        comandaNumber = extractedComanda;
      } catch (error) {
        toast.error('QRCode Inválido, verifique!');
        return;
      }
    }

    // Validação: verifica se é um número válido (string numérica ou number)
    const numValue = Number(comandaNumber);
    if (isNaN(numValue)) {
      toast.error('QRCode Inválido, verifique!');
      return;
    }

    setModalCamera(false);
    setModalLoading(true);
    handleSocketEmit(numValue);
  };

  useEffect(() => {
    if (!isObjectEmpty(socketResponse)) {
      handleResposta(socketResponse);
    }
  }, [socketResponse, handleResposta]);

  const handleItemClick = (_id) => {
    if (!statusLoja.StatusLoja) {
      toast.error('Loja Fechada');
      return;
    }

    const whats =
      'https://api.whatsapp.com/send?text=Oi&phone=55' +
      dadosApp.Empresa.Config.whatsapp_gerencia_ddd +
      dadosApp.Empresa.Config.whatsapp_gerencia_telefone;
    switch (_id) {
      case 1: // Pedido
        param.closeModal();
        break;

      case 2: // Conta
        if (dadosApp.Empresa.Config.mesa_cartao_hibrido) {
          setModalPergunta(true);
          return;
        }

        // PORTARIA = CARTÃO
        if (dadosApp.portaria) {
          setModalCamera(true);
          //handleQrCode(2); // para testes
        } else {
          setModalLoading(true);
          handleSocketEmit();
        }
        break;

      case 3: // Cardápio
        window.open(dadosApp.Empresa.Config.cardapio_caminho, '_blank');
        break;

      case 4: // LOGIN / MEUS DADOS
        if (!user.ativo) {
          setModalLogin(true);
        } else {
          setModalMeusDados(true);
        }
        break;

      case 5: // Cartões
        setModalCartoes(true);
        break;

      case 6: // Deslogar
        handleLogout();
        break;

      case 7: // Fale Conosco
        //window.location.href = whats;
        window.open(whats);
        break;

      default:
        break;
    }
  };

  return (
    <div>
      <div className="container padTop20" style={{ padding: 0, textAlign: 'center', paddingBottom: 25 }}>
        {!statusLoja.StatusLoja && (
          <p style={{ width: '100%', color: 'white', background: '#0f0f0f', fontWeight: 700, lineHeight: '50px' }}>
            Loja Fechada
          </p>
        )}
        {options
          .filter(({ disabled }) => !disabled)
          .map((item) => (
            // <section key={item._id} className="page-section" style={{ display: 'inline-block' }}>
            <section key={item._id} className="page-section" style={{ display: 'inline-block' }}>
              <div onClick={() => handleItemClick(item._id)} style={{ backgroundColor: 'white', borderRadius: 20 }}>
                <a className="item" style={{ borderRadius: 20, width: 160, margin: 7 }}>
                  <div style={{ textAlign: 'center' }}>
                    <img src={item.icon} style={{ opacity: statusLoja.StatusLoja ? '1' : '0.1' }} />

                    <p
                      style={{
                        color: statusLoja.StatusLoja ? 'black' : 'gainsboro',
                        // textTransform: 'capitalize',
                        fontWeight: 'bold',
                        marginTop: 10,
                        marginBottom: 20,
                      }}
                    >
                      {item.text}
                    </p>
                    {/* <p style={{ color: statusLoja.StatusLoja ? '#777' : 'gainsboro', marginTop: 10, fontSize: 12 }}>
                      {item.description}
                    </p> */}
                  </div>
                </a>
              </div>
            </section>
          ))}
      </div>
      {modalPergunta && (
        <Modal
          title={'Você possui comanda?'}
          isFooter={false}
          visibility={modalPergunta ? 'block' : 'none'}
          page="CONFIRMACAO"
          param={{
            onClick: handleConfirmacaoTemComanda,
          }}
          btnOnClickClose={() => setModalPergunta(false)}
          customPosition="modal-position-bottom"
        />
      )}
      {modalLoading && (
        <Modal
          title=""
          isFooter={false}
          visibility={modalLoading ? 'block' : 'none'}
          param={{ msg: 'Aguarde...' }}
          page="LOADING"
          customPosition="loading-modal"
        />
      )}

      {modalLogin && (
        <Modal
          title="Login"
          isFooter={true}
          visibility={modalLogin ? 'block' : 'none'}
          page="LOGIN"
          btnOnClickClose={() => setModalLogin(false)}
        />
      )}

      {modalMeusDados && (
        <Modal
          title="Meus Dados"
          isFooter={false}
          visibility={modalMeusDados ? 'block' : 'none'}
          page="MEUS_DADOS"
          btnOnClickClose={() => setModalMeusDados(false)}
        />
      )}

      {modalCartoes && (
        <Modal
          title="Cartões"
          isFooter={false}
          visibility={modalCartoes ? 'block' : 'none'}
          param={{
            isFinalizacao: false,
            //setPagOnlineSelecionado: setPagOnlineSelecionado,
            closeModal: () => setModalCartoes(false),
          }}
          page="LISTA_CARTOES"
          btnOnClickClose={() => setModalCartoes(false)}
        />
      )}

      {modalConferencia && (
        <Modal
          title={title}
          isFooter={false}
          visibility={modalConferencia ? 'block' : 'none'}
          param={{
            origin: 'modal',
            itens: itens,
            closeModal: () => setModalConferencia(false),
          }}
          page="CONFERENCIA"
          btnOnClickClose={() => setModalConferencia(false)}
        />
      )}
      {modalCamera && (
        <Modal
          title="Escaneie sua Comanda"
          isFooter={false}
          visibility={modalCamera ? 'block' : 'none'}
          param={{
            origin: 'modal',
            onClick: handleQrCode,
            showHideModal: () => setModalCamera(false),
            title: 'Escaneie sua Comanda',
          }}
          page="QR_CODE"
          btnOnClickClose={() => setModalCamera(false)}
          customPosition="modal-position-bottom"
        />
        // <Modal
        //   title={'Escaneie sua Comanda'}
        //   isFooter={false}
        //   visibility={modalCamera ? 'block' : 'none'}
        //   param={{
        //     origin: 'modal',
        //     itens: itens,
        //     closeModal: () => setModalCamera(false),
        //   }}
        //   page="QR_CODE"
        //   btnOnClickClose={() => setModalCamera(false)}
        // />
      )}
    </div>
  );
};

AutoAtendimento.propTypes = {
  param: P.object,
};
